var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9a634fe59ce130e2a7809233f01f7c2bc0a92e4d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["versum-web@versum-studios"]={id:"9a634fe59ce130e2a7809233f01f7c2bc0a92e4d"};
      